import {CAT_ANALYTICS, CAT_FUNCTIONALITY, CAT_NECESSARY} from "../ConsentCookieDefinitions";

// Seccion Encabezado de la Modal de Preferencias
const SECTION_PRIMARY_DEF = {
  description: `<span>Puede configurar y / o aceptar el uso de cookies mediante las casillas que se muestran a continuación.</span>
<span>Si quieres más información puedes visitar nuestra <a href="/politica-de-cookies-ue" target="_blank"><strong>Política ampliada de cookies</strong></a></span>
`
};

// Seccion Cookies Necesarias de la Modal de Preferencias
const SECTION_NECESSARY_DEF = {
  title: 'Técnicas (Necesarias)',
  description:'Las cookies estrictamente necesarias garantizan funciones que son indispensables para el funcionamiento adecuado de la página web. Como resultado, estas cookies no pueden desactivarse. Se utilizan de forma exclusiva en esta página web y, por lo tanto, son cookies propias. Esto significa que toda la información almacenada en las cookies solo se mandará a esta web.',
  linkedCategory: CAT_NECESSARY
}

// Seccion Funcionales o personalizadas de la Modal de Preferencias
const SECTION_FUNCTIONALITY_DEF = {
  title: 'Preferencias',
  description:'Las cookies de preferencias permiten a la página web recordar información que cambia la forma en que la página se comporta o el aspecto que tiene, como su idioma preferido o la región en la que usted se encuentra.',
  linkedCategory: CAT_FUNCTIONALITY
};

// Seccion Analitica GOOGLE Tagmanager de la Modal de Preferencias
const SECTION_ANALYTICS_DEF = {
  title: 'Analíticas',
  description:
      'Las cookies estadísticas ayudan a los propietarios de páginas web a comprender cómo interactúan los visitantes con las páginas web reuniendo y proporcionando información de forma anónima.',
  linkedCategory: CAT_ANALYTICS,
  // cookieTable: SECTION_COOKIE_TABLE, // Si hace falta
};

//Si no es necesario no lo agregamos
const SECTION_COOKIE_TABLE = {
  caption: 'Analíticas',
  headers: {
    name: 'Nombre',
    prov: 'Proveedor',
    origin: 'Propia/Tercero',
    purpose: 'Proósito',
    expiry: 'Caducidad',
    type: 'Tipo',
  },
  body: [
    {
      name: '_ga',
      prov: 'Google',
      origin: 'Tercero',
      purpose: 'Se usa para distinguir a los usuarios.',
      expiry: '<a href="https://policies.google.com/technologies/cookies?hl=es#how-google-uses-cookies" target="_blank">Link</a>',
      type: 'HTTP Cookie',
      //domain: location.hostname,
      //desc: 'Description 1',
    },
    {
      name: '_gat',
      prov: 'Google',
      origin: 'Tercero',
      purpose: 'Se usa para limitar el porcentaje de solicitudes.',
      expiry: '<a href="https://policies.google.com/technologies/cookies?hl=es#how-google-uses-cookies" target="_blank">Link</a>',
      type: 'HTTP Cookie',
    },
    {
      name: '_gid',
      prov: 'Google',
      origin: 'Tercero',
      purpose: 'Registra una identificación única que se utiliza para generar datos estadísticos acerca de cómo utiliza el visitante el sitio web.',
      expiry: '<a href="https://policies.google.com/technologies/cookies?hl=es#how-google-uses-cookies" target="_blank">Link</a>',
      type: 'HTTP Cookie',
    },
  ],
}

export const CONFIGURATION_ES = {
  consentModal: {
    description:
        `Indra Sistemas S.A., utiliza cookies, propias y de terceros, con la finalidad de registrar las actividades de navegación del usuario, cuantificar el número de usuarios y realizar medición y análisis estadístico del uso que hacen los usuarios del servicio ofertado.  Puedes configurar y/o aceptar el uso de cookies mediante las casillas que se muestran a continuación. Si deseas más información, puedes visitar nuestra <a href="/politica-de-cookies-ue">Política ampliada de cookies</a>`,
    acceptAllBtn: 'Permitir todas las cookies',
    acceptNecessaryBtn: 'Usar solo las necesarias',
    showPreferencesBtn: 'Configurar cookies',
  },
  preferencesModal: {
    title: 'Configuración de preferencias de cookies',
    acceptAllBtn: 'Aceptar todo',
    acceptNecessaryBtn: 'Rechazar',
    savePreferencesBtn: 'Guardar ajustes',
    closeIconLabel: 'Cerrar',
    //serviceCounterLabel: 'Service|Services',
    sections: [
      SECTION_PRIMARY_DEF,
      SECTION_NECESSARY_DEF,
      //SECTION_FUNCTIONALITY_DEF,
      SECTION_ANALYTICS_DEF,
    ],
  },
}
